import EditCategories from './EditCategories';
export default EditCategories;